import Vue from 'vue'
import VueEvents from 'vue-events'
import '@babel/polyfill'
import 'whatwg-fetch'

// bootstrap imports
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './site.scss'

// import out plug-in
import ReportingApi from '@vigilantapps/vipro-cloud-reporting-api-client'

import App from './App.vue'
import router from './router'
import store from './store'
import NumberFilters from './plugins/filters-number'
import OidcUserFilters from './plugins/filters-oidcuser'
import PanEssexFilters from './plugins/filters-panessex'

Vue.config.productionTip = false
Vue.use(VueEvents)

// momentjs
Vue.use(require('vue-moment'))

// bootstrap styles
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// our plug-ins
Vue.use(NumberFilters)
Vue.use(OidcUserFilters)
Vue.use(PanEssexFilters)
Vue.use(ReportingApi, {
  endpoints: {
    panessex: 'https://api2.panessex.co.uk'
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
